import React from 'react';
import LegalLayout, { LegalSection } from '../components/layout/LegalLayout';

export default function LegalPage() {
  return (
    <LegalLayout title="Mentions Légales" lastUpdated="Janvier 2025">
      <p className="italic text-linx_text-muted">
        Informations légales obligatoires relatives aux services et opérations LinxExpress en Tunisie.
      </p>

      <LegalSection title="Informations sur l'Entreprise">
        <p>LinxExpress est un produit exploité par AGODEV SOLUTIONS SARL, RNE: B509612026, MF: 1958385L, siège social : avenue Habib Bourguiba Teboulbou Gabès 6032, Tunisie.</p>
      </LegalSection>

      <LegalSection title="Licences">
        <p>LinxExpress opère en tant que plateforme numérique de mise en relation. Les chauffeurs sont des professionnels indépendants responsables du maintien et de la présentation de tous permis, autorisations et documents requis pour leur activité.</p>
      </LegalSection>

      <LegalSection title="Couverture d'Assurance">
        <p>Sauf offre écrite spécifique, LinxExpress ne fournit pas d'assurance marchandise standard couvrant toutes les courses. Les transporteurs restent responsables des risques d'exécution du transport.</p>
      </LegalSection>

      <LegalSection title="Protection des Données">
        <p>LinxExpress applique des mesures de protection des données et traite les données personnelles conformément au droit tunisien. Veuillez consulter notre Politique de Confidentialité pour les détails.</p>
      </LegalSection>

      <LegalSection title="Propriété Intellectuelle">
        <p>Le nom LinxExpress, le logo, le logiciel, les interfaces et contenus sont protégés par le droit de la propriété intellectuelle. Toute reproduction, extraction, ingénierie inverse ou exploitation commerciale non autorisée est interdite.</p>
      </LegalSection>

      <LegalSection title="Résolution des Litiges">
        <p>Avant toute procédure judiciaire, les parties doivent tenter une résolution amiable dans un délai de quinze (15) jours. Les litiges sont soumis au droit tunisien et à la compétence des tribunaux de Gabès, Tunisie.</p>
      </LegalSection>

      <LegalSection title="Contact">
        <p>Toute notification juridique doit être adressée à contact@agodevsolutions.com. En cas de divergence entre versions linguistiques, la version française prévaut.</p>
      </LegalSection>
    </LegalLayout>
  );
}
